/* Sam's Fragrances wishlist (replaces Wishlist Hero). 2026-09-26.
   Storage: localStorage 'sf_wl' = [{h: handle, t: addedAt}]. No MutationObserver on <body>:
   cards are scanned on load, on 'sf:products-appended', and when the facet grid is swapped. */
(function () {
  'use strict';
  if (window.__sfWL) return; window.__sfWL = true;
  var KEY = 'sf_wl', PAGE = '/pages/wishlist', cache = {};
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.2-1.1C6.1 15 3 12.2 3 8.7 3 5.9 5.2 3.8 7.9 3.8c1.6 0 3.1.7 4.1 1.9 1-1.2 2.5-1.9 4.1-1.9 2.7 0 4.9 2.1 4.9 4.9 0 3.5-3.1 6.3-7.8 10.5L12 20.3z"/></svg>';

  /* ---------- storage ---------- */
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); if (!Array.isArray(a)) return []; var seen = {}; return a.filter(function (x) { if (!x || !x.h || seen[x.h]) return false; seen[x.h] = 1; return true; }); } catch (e) { return []; } }
  function write(a, fromServer) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} if (!fromServer) queueSync(); }

  /* ---------- account sync (logged-in customers; /apps/wishlist app proxy -> customer metafield) ---------- */
  var SYNC = '/apps/wishlist', syncT, syncOn = false;
  function customerId() {
    try { return (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId) || (window.__st && window.__st.cid) || null; } catch (e) { return null; }
  }
  function syncState() { try { return JSON.parse(localStorage.getItem('sf_wl_sync') || '{}'); } catch (e) { return {}; } }
  function setSyncState(o) { try { localStorage.setItem('sf_wl_sync', JSON.stringify(o)); } catch (e) {} }
  function queueSync() {
    var cid = customerId(); if (!cid) return;
    var st = syncState(); st.cid = String(cid); st.dirty = true; setSyncState(st);
    if (!syncOn) return; // first pull not done yet; it will push the merged list
    clearTimeout(syncT); syncT = setTimeout(pushSync, 600);
  }
  function pushSync() {
    fetch(SYNC, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: read() }) })
      .then(function (r) { if (r.ok) { var st = syncState(); st.dirty = false; setSyncState(st); } }).catch(function () {});
  }
  function pullSync(done) {
    var cid = customerId(), st0 = syncState();
    if (!cid) { // logged out: never leave the previous account's list on a shared device
      if (st0.cid) { try { localStorage.removeItem(KEY); localStorage.removeItem('sf_wl_sync'); } catch (e) {} if (done) done(); }
      return;
    }
    fetch(SYNC, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.loggedIn) return;
      var st = syncState(), first = st.cid !== String(cid), local = read(), server = j.items || [];
      var out;
      var otherAccount = first && st.cid; // a different customer was signed in on this device: do not merge their list
      if ((first || st.dirty) && !otherAccount) { // guest->login or unsynced edits: merge both, keep the earliest "added" time
        var map = {}; server.concat(local).forEach(function (x) { if (!map[x.h] || x.t < map[x.h].t) map[x.h] = x; });
        out = Object.keys(map).map(function (k) { return map[k]; }).sort(function (a, b) { return b.t - a.t; });
      } else out = server;       // this device is in sync: the account is the source of truth (removals elsewhere apply)
      var changed = JSON.stringify(out.map(function (x) { return x.h; })) !== JSON.stringify(local.map(function (x) { return x.h; }));
      write(out, true); setSyncState({ cid: String(cid), dirty: false }); syncOn = true;
      if ((first || st.dirty) && !otherAccount) pushSync();
      if (changed && done) done();
    }).catch(function () {});
  }
  function has(h) { return read().some(function (x) { return x.h === h; }); }
  function handleFromUrl(u) { var m = String(u || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  // import anything saved in Wishlist Hero on this device. Each handle is imported once
  // (tracked in sf_wl_imported), so an item the shopper later removes never comes back.
  (function migrate() {
    try {
      var old = JSON.parse(localStorage.getItem('wishlisthero_.wl-itms') || '[]');
      if (!Array.isArray(old) || !old.length) return;
      var done = JSON.parse(localStorage.getItem('sf_wl_imported') || '{}');
      var a = read(), seen = {}, changed = false;
      a.forEach(function (x) { seen[x.h] = 1; });
      old.forEach(function (o) {
        if (!o) return;
        var h = o.ProductHandle || o.productHandle || handleFromUrl(o.ProductLink || o.productLink);
        if (!h || done[h]) return;
        done[h] = 1; changed = true;
        if (!seen[h]) { seen[h] = 1; a.push({ h: h, t: Date.parse(o.AddedOn) || Date.now() }); }
      });
      if (changed) { write(a); localStorage.setItem('sf_wl_imported', JSON.stringify(done)); }
    } catch (e) {}
  })();

  /* ---------- toast (counts quick taps) ---------- */
  var tEl, tTimer, burst = 0, burstTimer;
  function toast(msg, action, fn) {
    if (!tEl) { tEl = document.createElement('div'); tEl.id = 'sf-wl-toast'; tEl.setAttribute('role', 'status'); tEl.setAttribute('aria-live', 'polite'); document.body.appendChild(tEl); }
    tEl.textContent = msg;
    if (action) { var b = document.createElement('button'); b.type = 'button'; b.className = 'sf-wl-toast__btn'; b.textContent = action; b.onclick = function () { tEl.classList.remove('is-on'); fn(); }; tEl.appendChild(b); }
    tEl.classList.toggle('has-action', !!action); tEl.classList.add('is-on');
    clearTimeout(tTimer); tTimer = setTimeout(function () { tEl.classList.remove('is-on'); }, action ? 5000 : 1800);
  }

  /* ---------- sync every heart + the header count ---------- */
  function paint() {
    var a = read(), set = {};
    a.forEach(function (x) { set[x.h] = 1; });
    document.querySelectorAll('.sf-wl-btn').forEach(function (b) {
      var on = !!set[b.dataset.h];
      if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
      if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.getAttribute('aria-label') !== (on ? 'Remove from wishlist' : 'Add to wishlist')) b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var lbl = b.querySelector('.sf-wl-btn__label'); if (lbl && lbl.textContent !== (on ? 'Saved to wishlist' : 'Add to wishlist')) lbl.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('.sf-wl-count').forEach(function (c) { var was = c.textContent; var sfNt = String(a.length > 99 ? '99+' : a.length); if (c.textContent !== sfNt) c.textContent = sfNt; c.hidden = !a.length; c.classList.toggle('is-wide', a.length > 9); if (was && was !== c.textContent) { c.classList.remove('sf-count-pop'); void c.offsetWidth; c.classList.add('sf-count-pop'); } });
    document.querySelectorAll('.header__icon--wishlist').forEach(function (h) { h.setAttribute('aria-label', 'Wishlist' + (a.length ? ' (' + a.length + (a.length === 1 ? ' item)' : ' items)') : '')); });
  }

  function toggle(h, btn) {
    var a = read(), i = -1;
    a.forEach(function (x, k) { if (x.h === h) i = k; });
    var adding = i < 0;
    if (adding) a.unshift({ h: h, t: Date.now() }); else a.splice(i, 1);
    write(a); paint();
    if (btn) { btn.classList.remove('sf-pop'); void btn.offsetWidth; btn.classList.add('sf-pop'); }
    var hdr = document.querySelector('.header__icon--wishlist');
    if (hdr) { hdr.classList.remove('sf-bump'); void hdr.offsetWidth; hdr.classList.add('sf-bump'); }
    clearTimeout(burstTimer); burst = adding ? burst + 1 : 0; burstTimer = setTimeout(function () { burst = 0; }, 2500);
    toast(adding ? (burst > 1 ? burst + ' items added to wishlist' : 'Added to wishlist') : 'Removed from wishlist');
    if (adding) klaviyoTrack(h);
    document.dispatchEvent(new CustomEvent('sf:wishlist-change', { detail: { handle: h, added: adding } }));
  }

  // Report every wishlist add to Klaviyo, GA4 (standard add_to_wishlist) and Meta (standard AddToWishlist),
  // so "most wishlisted" shows up in GA4 reports and Meta can use it for ads. Meta's catalogue keys on variant id.
  function klaviyoTrack(h) {
    getProduct(h).then(function (p) {
      if (!p) return;
      var v = firstAvailable(p) || p.variants[0], price = (v ? v.price : p.price) / 100;
      try {
        if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Added to Wishlist', {
          ProductName: p.title, ProductID: p.id, Brand: p.vendor, Price: price,
          URL: location.origin + '/products/' + p.handle, ImageURL: p.featured_image ? 'https:' + p.featured_image.replace(/^https?:/, '') : ''
        }]);
      } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'add_to_wishlist', { currency: 'USD', value: price, items: [{ item_id: String(v ? v.id : p.id), item_name: p.title, item_brand: p.vendor, price: price, quantity: 1 }] }); } catch (e) {}
      try { if (window.fbq) window.fbq('track', 'AddToWishlist', { content_ids: [String(v ? v.id : p.id)], content_name: p.title, content_type: 'product', value: price, currency: 'USD' }); } catch (e) {}
    });
  }

  // one delegated handler — no per-button listeners, nothing to leak on re-render
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sf-wl-btn');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.dataset.h, b);
  }, true);

  function makeBtn(h, withLabel) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sf-wl-btn' + (withLabel ? ' sf-wl-btn--pdp button button--secondary' : ' sf-wl-btn--card');
    b.dataset.h = h;
    b.innerHTML = HEART + (withLabel ? '<span class="sf-wl-btn__label">Add to wishlist</span>' : '');
    return b;
  }

  /* ---------- hearts on product cards ---------- */
  function scanCards(root) {
    (root || document).querySelectorAll('.product-card-wrapper, .card-wrapper').forEach(function (card) {
      if (card.querySelector('.sf-wl-btn')) return;
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = handleFromUrl(a.getAttribute('href')); if (!h) return;
      var host = card.querySelector('.card__inner') || card;
      host.appendChild(makeBtn(h, false));
    });
  }

  /* ---------- button on the product page ---------- */
  function scanPdp() {
    var can = document.querySelector('link[rel="canonical"]');
    var h = can && handleFromUrl(can.href); if (!h) return;
    document.querySelectorAll('.product-form__buttons').forEach(function (box) {
      if (box.querySelector('.sf-wl-btn')) return;
      box.appendChild(makeBtn(h, true));
    });
  }

  /* ---------- header icon -> our page, our count ---------- */
  function wireHeader() {
    document.querySelectorAll('a[href$="#hero-wishlist"], .header__icon--wishlist').forEach(function (a) {
      if (a.tagName === 'A') a.setAttribute('href', PAGE);
      if (!a.querySelector('.sf-wl-count')) { var s = document.createElement('span'); s.className = 'sf-wl-count cart-count-bubble'; s.setAttribute('aria-hidden', 'true'); a.appendChild(s); }
    });
    document.querySelectorAll('a[href$="/a/wishlist-hero/wishlist"], a.wlh-drawer-link').forEach(function (a) {
      a.setAttribute('href', PAGE);
      if (a.closest('.menu-drawer') && !a.querySelector('.sf-wl-count')) { var s = document.createElement('span'); s.className = 'sf-wl-count sf-wl-count--inline'; s.setAttribute('aria-hidden', 'true'); a.appendChild(s); }
    });
  }

  /* ---------- the wishlist page ---------- */
  function money(c) { var n = c / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; u = u.replace(/^https?:/, ''); return 'https:' + u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  // Last-seen product details, so the wishlist page can draw instantly and refresh behind the scenes.
  var SNAP = 'sf_wl_pc';
  function snaps() { try { return JSON.parse(localStorage.getItem(SNAP) || '{}') || {}; } catch (e) { return {}; } }
  function slim(p) {
    return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, featured_image: p.featured_image, options: p.options,
      variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available, featured_image: v.featured_image ? { src: v.featured_image.src } : null }; }) };
  }
  function saveSnap(p) {
    try { var o = snaps(); o[p.handle] = slim(p); var k = Object.keys(o); if (k.length > 160) k.slice(0, k.length - 160).forEach(function (x) { delete o[x]; });
      localStorage.setItem(SNAP, JSON.stringify(o)); } catch (e) {}
  }
  function getProduct(h) {
    if (cache[h]) return cache[h];
    return (cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { saveSnap(p); return p; }).catch(function () { return null; }));
  }
  function firstAvailable(p) { return p.variants.filter(function (v) { return v.available; })[0] || null; }

  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (drawer && drawer.renderContents && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else location.href = '/cart';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('loading'); } });
  }

  function ago(t) {
    if (!t) return '';
    var d = Math.floor((Date.now() - t) / 864e5);
    return d <= 0 ? 'Added today' : d === 1 ? 'Added yesterday' : d < 30 ? 'Added ' + d + ' days ago' : 'Added ' + new Date(t).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }
  var sortBy = 'recent';
  try { sortBy = sessionStorage.getItem('sf_wl_sort') || 'recent'; } catch (e) {}

  function renderPage(root, fresh) {
    var params = new URLSearchParams(location.search);
    var shared = params.get('items');
    var list = shared ? shared.split(',').map(decodeURIComponent).filter(Boolean).slice(0, 60).map(function (h) { return { h: h, t: 0 }; }) : read();
    var handles = list.map(function (x) { return x.h; }), added = {};
    list.forEach(function (x) { added[x.h] = x.t; });
    root.innerHTML = '<div class="sf-wlp page-width">'
      + '<div class="sf-wlp__head"><div><h2 class="sf-wlp__title h1">' + (shared ? 'Shared wishlist' : 'My Wishlist') + '</h2><p class="sf-wlp__count"></p></div><div class="sf-wlp__actions"></div></div>'
      + '<div class="sf-wlp__bar" hidden></div><ul class="sf-wlp__grid" role="list"></ul></div>';
    var grid = root.querySelector('.sf-wlp__grid'), countEl = root.querySelector('.sf-wlp__count'), actions = root.querySelector('.sf-wlp__actions'), bar = root.querySelector('.sf-wlp__bar');
    if (!handles.length) {
      grid.outerHTML = '<div class="sf-wlp__empty">' + HEART + '<h2>Your wishlist is empty</h2><p>Tap the heart on any product to save it here for later.</p>'
        + '<div class="sf-wlp__empty-links"><a class="button" href="/collections/bestsellers">Shop bestsellers</a><a class="button button--secondary" href="/collections/new-drop">New arrivals</a></div></div>';
      return;
    }
    var sn = snaps(), fromSnap = !fresh && handles.every(function (h) { return sn[h]; });
    if (!fromSnap) grid.innerHTML = handles.map(function () { return '<li class="sf-wlp__item is-loading"><div class="sf-wlp__media"></div><div class="sf-wlp__line"></div><div class="sf-wlp__line sf-wlp__line--s"></div></li>'; }).join('');
    if (fromSnap) { // draw now from last-seen details, then quietly refresh prices/stock and redraw only if something changed
      var before = JSON.stringify(handles.map(function (h) { return sn[h]; }));
      Promise.all(handles.map(getProduct)).then(function (ps) {
        var after = JSON.stringify(ps.map(function (p) { return p ? slim(p) : null; }));
        if (after !== before) renderPage(root, true);
      });
    }

    (fromSnap ? Promise.resolve(handles.map(function (h) { return sn[h]; })) : Promise.all(handles.map(getProduct))).then(function (ps) {
      var live = [];
      ps.forEach(function (p, i) { if (p) live.push(p); else if (!shared) write(read().filter(function (x) { return x.h !== handles[i]; })); });
      var chosen = {};
      live.forEach(function (p) { chosen[p.handle] = firstAvailable(p) || p.variants[0]; });
      var buyable = function () { return live.filter(function (p) { return chosen[p.handle] && chosen[p.handle].available; }); };

      function priceHtml(v) {
        var sale = v.compare_at_price > v.price;
        return (sale ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + '<span' + (sale ? ' class="is-sale"' : '') + '>' + money(v.price) + '</span>';
      }
      function badge(v) { return !v.available ? '<span class="sf-wlp__badge sf-wlp__badge--out">Sold out</span>' : v.compare_at_price > v.price ? '<span class="sf-wlp__badge">-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : ''; }
      function ctaHtml(p, v) {
        return v.available ? '<button type="button" class="button sf-wlp__add" data-v="' + v.id + '">Add to cart</button>'
          : '<a class="button button--secondary sf-wlp__soldout" href="/products/' + esc(p.handle) + '?variant=' + v.id + '">Sold out – notify me</a>';
      }
      function summary() {
        var b = buyable(), total = b.reduce(function (n, p) { return n + chosen[p.handle].price; }, 0);
        countEl.textContent = live.length + (live.length === 1 ? ' item' : ' items') + (b.length ? ' · ' + money(total) + ' total' : '') + (b.length < live.length ? ' · ' + (live.length - b.length) + ' sold out' : '');
        var all = actions.querySelector('.sf-wlp__all'); if (all) all.hidden = b.length < 2;
      }
      function order() {
        var a = live.slice();
        if (sortBy === 'price-asc') a.sort(function (x, y) { return chosen[x.handle].price - chosen[y.handle].price; });
        else if (sortBy === 'price-desc') a.sort(function (x, y) { return chosen[y.handle].price - chosen[x.handle].price; });
        else if (sortBy === 'sale') a.sort(function (x, y) { var sx = chosen[x.handle].compare_at_price > chosen[x.handle].price, sy = chosen[y.handle].compare_at_price > chosen[y.handle].price; return sy - sx; });
        return a;
      }
      function draw() {
        grid.innerHTML = order().map(function (p, i) {
          var v = chosen[p.handle], multi = p.variants.length > 1;
          return '<li class="sf-wlp__item" style="--i:' + i + '" data-h="' + esc(p.handle) + '">'
            + '<a class="sf-wlp__media" href="/products/' + esc(p.handle) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 600)) + '" alt="' + esc(p.title) + '"' + (i < 4 ? '' : ' loading="lazy"') + ' width="600" height="600">' : '') + badge(v) + '</a>'
            + (shared ? '' : '<button type="button" class="sf-wlp__remove" data-h="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + '">' + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>')
            + '<p class="sf-wlp__vendor">' + esc(p.vendor) + '</p>'
            + '<a class="sf-wlp__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>'
            + (multi ? '<select class="sf-wlp__variant" aria-label="Choose option">' + p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + (x.available ? '' : ' – sold out') + '</option>'; }).join('') + '</select>' : '')
            + '<p class="sf-wlp__price">' + priceHtml(v) + '</p>'
            + (shared || !added[p.handle] ? '' : '<p class="sf-wlp__date">' + ago(added[p.handle]) + '</p>')
            + '<div class="sf-wlp__cta">' + ctaHtml(p, v) + '</div>'
            + (shared ? '<button type="button" class="sf-wlp__save link" data-h="' + esc(p.handle) + '">' + (has(p.handle) ? 'In your wishlist' : 'Save to my wishlist') + '</button>' : '')
            + '</li>';
        }).join('');
        summary();
        try { if (!window.__sfWlDrawn) { window.__sfWlDrawn = performance.now(); window.__sfWlFrom = fromSnap ? 'saved' : 'network'; } } catch (e) {}
      }

      var listUrl = location.origin + PAGE + '?items=' + live.map(function (p) { return encodeURIComponent(p.handle); }).join(',');
      var msg = 'My wishlist at Sam’s Fragrances: ' + listUrl;
      var IC = {
        link: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg>',
        wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20l1.2-3.6A8 8 0 1 1 8 19z"/><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.4-1.8-.9-.8.8a4 4 0 0 1-2.3-2.3l.8-.8-.9-1.8z"/></svg>',
        mail: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="13" rx="1.5"/><path d="M4 7l8 6 8-6"/></svg>'
      };
      actions.innerHTML = '<button type="button" class="button sf-wlp__all" hidden>Add all to cart</button>'
        + (shared ? '' : '<div class="sf-wlp__share-group"><span class="sf-wlp__share-label">Share</span>'
          + '<button type="button" class="sf-wlp__icon sf-wlp__share" aria-label="Copy link" title="Copy link">' + IC.link + '</button>'
          + '<a class="sf-wlp__icon" target="_blank" rel="noopener" aria-label="Share on WhatsApp" title="WhatsApp" href="https://wa.me/?text=' + encodeURIComponent(msg) + '">' + IC.wa + '</a>'
          + '<a class="sf-wlp__icon" aria-label="Share by email" title="Email" href="mailto:?subject=' + encodeURIComponent('My Sam’s Fragrances wishlist') + '&body=' + encodeURIComponent(live.map(function (p) { return '- ' + p.title; }).join('\n') + '\n\n' + listUrl) + '">' + IC.mail + '</a></div>');
      bar.hidden = false;
      bar.innerHTML = (shared ? '<span></span>' : '<button type="button" class="sf-wlp__clear">Clear all</button>')
        + (live.length > 1 ? '<label class="sf-wlp__sort">Sort by <select><option value="recent">Recently added</option><option value="price-asc">Price, low to high</option><option value="price-desc">Price, high to low</option><option value="sale">On sale first</option></select></label>' : '');
      var sel = bar.querySelector('select');
      if (sel) { sel.value = sortBy; sel.onchange = function () { sortBy = sel.value; try { sessionStorage.setItem('sf_wl_sort', sortBy); } catch (e) {} draw(); }; }
      draw();

      root.onchange = function (e) {
        var s = e.target.closest('.sf-wlp__variant'); if (!s) return;
        var li = s.closest('.sf-wlp__item'), p = live.filter(function (x) { return x.handle === li.dataset.h; })[0];
        var v = p.variants.filter(function (x) { return x.id === +s.value; })[0]; chosen[p.handle] = v;
        li.querySelector('.sf-wlp__price').innerHTML = priceHtml(v);
        li.querySelector('.sf-wlp__cta').innerHTML = ctaHtml(p, v);
        var old = li.querySelector('.sf-wlp__badge'); if (old) old.remove();
        li.querySelector('.sf-wlp__media').insertAdjacentHTML('beforeend', badge(v));
        summary();
      };
      root.onclick = function (e) {
        var t = e.target;
        if (t.closest('.sf-wlp__remove')) {
          var h = t.closest('.sf-wlp__remove').dataset.h, li = t.closest('.sf-wlp__item');
          var before = read(), gone = before.filter(function (x) { return x.h === h; })[0], idx = before.indexOf(gone);
          li.classList.add('is-leaving');
          setTimeout(function () {
            write(before.filter(function (x) { return x.h !== h; })); paint(); renderPage(root);
            toast('Removed from wishlist', 'Undo', function () { var a = read(); a.splice(Math.max(0, idx), 0, gone); write(a); paint(); renderPage(root); });
          }, 240);
        } else if (t.closest('.sf-wlp__add')) {
          var b = t.closest('.sf-wlp__add');
          addToCart([{ id: +b.dataset.v, quantity: 1 }], b).then(function () { b.textContent = 'Added ✓'; b.classList.add('is-added'); setTimeout(function () { b.textContent = 'Add to cart'; b.classList.remove('is-added'); }, 2000); });
        } else if (t.closest('.sf-wlp__all')) {
          addToCart(buyable().map(function (p) { return { id: chosen[p.handle].id, quantity: 1 }; }), t.closest('.sf-wlp__all'));
        } else if (t.closest('.sf-wlp__share')) {
          if (navigator.clipboard) navigator.clipboard.writeText(listUrl).then(function () { toast('Link copied'); }, function () { prompt('Copy this link', listUrl); });
          else prompt('Copy this link', listUrl);
        } else if (t.closest('.sf-wlp__clear')) {
          if (confirm('Remove all items from your wishlist?')) {
            var all = read(); write([]); paint(); renderPage(root);
            toast('Wishlist cleared', 'Undo', function () { write(all); paint(); renderPage(root); });
          }
        } else if (t.closest('.sf-wlp__save')) {
          var sv = t.closest('.sf-wlp__save'); if (!has(sv.dataset.h)) { toggle(sv.dataset.h, null); sv.textContent = 'In your wishlist'; }
        }
      };
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    wireHeader(); scanCards(); scanPdp(); paint();
    var page = document.getElementById('sf-wl-page');
    if (page) renderPage(page);
    pullSync(function () { paint(); if (page) renderPage(page); });
    // warm saved details for items synced from another device, so the wishlist page draws instantly
    var warm = function () { var sn = snaps(); read().filter(function (x) { return !sn[x.h]; }).slice(0, 30).forEach(function (x) { getProduct(x.h); }); };
    if (!page) setTimeout(warm, 3500);
    // re-scan only where cards are replaced (filters, load more, recommendations) — never observe <body>
    var t;
    var rescan = function () { cancelAnimationFrame(t); t = requestAnimationFrame(function () { scanCards(); scanPdp(); paint(); }); };
    document.addEventListener('sf:products-appended', rescan);
    ['#ProductGridContainer', 'product-recommendations', '.product__info-wrapper', '#predictive-search-results'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { new MutationObserver(rescan).observe(el, { childList: true, subtree: sel !== '#ProductGridContainer' ? true : false }); });
    });
    window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); }); // other tabs
    window.addEventListener('pageshow', paint); // back/forward cache
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.sfWishlist = { read: read, toggle: toggle, paint: paint };
})();
